<ng-container *ngIf="!isLoading">
  <mat-form-field>
    <input (keyup)="validate()" [(ngModel)]="password" matInput name="password" placeholder="{{'login.password.ph_password' | translate}}"
           [type]="isPasswordVisible ? 'text' : 'password'">
    <mat-icon (click)="isPasswordVisible = !isPasswordVisible">{{ isPasswordVisible ? 'visibility_off' : 'visibility' }}</mat-icon>
    <mat-hint [class]="hints?.password?.level">{{hints?.password?.message}}</mat-hint>
  </mat-form-field>

  <mat-form-field>
    <input (keyup)="validate()" [(ngModel)]="passwordConfirm" matInput name="passwordConfirm"
           placeholder="{{'login.password.ph_passwordConfirmation' | translate}}" [type]="isPasswordVisible ? 'text' : 'password'">
    <mat-hint *ngIf="password !== passwordConfirm" [class]="hints?.passwordConfirm?.level">{{hints?.passwordConfirm?.message}}</mat-hint>
  </mat-form-field>
</ng-container>

